import { fullAccessLevels, halfAccessLevels } from '../accessLevels';
import ActionTypes from '../actions/types';
import moment from 'moment';

const queryParams = new URLSearchParams(window.location.search);

/**
 * @interface stateReducerType
 */

const initialState = {
  showLoader: false,
  hoverTabelSortLabel: '',
  // selectedDate:'',
  showAdvancedBoard: false,
  bidAskMid: 'ask',
  isVolClicked: false,
  isdata: [],
  hideShading: false,
  showModal: false,
  warningsRemoved: {},
  localUOA: [],
  fullUOA: [],
  stockFilter: false,
  etfFilter: false,
  smallFilter: false,
  midFilter: false,
  largeFilter: false,
  IVUP: false,
  IVDOWN: false,
  page: 1,
  rowsPerPage: 20,
  nextRefreshTime: '',
  time: '',
  showVideo: false,
  refreshUOA: true,
  date: moment().format('YYYY-MM-DD'),
  check: false,
  showUOAMODAL: false,
  modalRowData: {},
  newData: [],
};

const levels = queryParams.get('levels');

if (levels) {
  const splitedLevels = levels.split(',');
  const fullAccess = splitedLevels.some((mem) =>
    fullAccessLevels.includes(mem)
  );
  const halfAccess = splitedLevels.some((mem) =>
    halfAccessLevels.includes(mem)
  );

  if (fullAccess && Object.keys(fullAccess).length) {
    initialState.accessLevel = 'fullaccess';
    initialState.redirectLink = '/home';
  } else if (halfAccess && Object.keys(halfAccess).length) {
    initialState.accessLevel = 'halfaccess';
    initialState.redirectLink = '/unusualoptionsactivity';
  } else {
    initialState.redirectLink = '/unusualoptionsactivity';
    // window.location.replace("https://optionsgeek.com/welcome-home-page");
  }
}

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.SET_UOA_STATE:
      return {
        ...state,
        ...payload,
      };
    case ActionTypes.SET_UOA_FILTER:
      var {
        stockFilter,
        etfFilter,
        smallFilter,
        midFilter,
        largeFilter,
        IVUP,
        IVDOWN,
      } = state;

      switch (payload) {
        case 'all1':
          stockFilter = false;
          etfFilter = false;
          return {
            ...state,
            stockFilter: stockFilter,
            etfFilter: etfFilter,
          };

        case 'stock':
          stockFilter = !stockFilter;
          return { ...state, stockFilter: stockFilter };

        case 'etf':
          etfFilter = !etfFilter;
          return { ...state, etfFilter: etfFilter };

        case 'all2':
          smallFilter = false;
          midFilter = false;
          largeFilter = false;
          return {
            ...state,
            smallFilter: false,
            midFilter: false,
            largeFilter: false,
          };

        case 'Small':
          smallFilter = !smallFilter;
          return { ...state, smallFilter: smallFilter };

        case 'Mid':
          midFilter = !midFilter;
          return { ...state, midFilter: midFilter };

        case 'Large':
          largeFilter = !largeFilter;
          return { ...state, largeFilter: largeFilter };

        case 'all3':
          IVUP = false;
          IVDOWN = false;
          return {
            ...state,
            IVUP: false,
            IVDOWN: false,
          };

        case 'IVUP':
          IVUP = !IVUP;
          return { ...state, IVUP: IVUP };

        case 'IVDOWN':
          IVDOWN = !IVDOWN;
          return { ...state, IVDOWN: IVDOWN };

        default:
          // console.log('Invalid case value');
          return state;
      }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/UOAState.js